import React, { createContext, useContext } from 'react';

const Context = createContext();
const useEditorState = () => useContext(Context);

const EditorStateProvider = ({ value, children }) => {
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export { EditorStateProvider, useEditorState };
